import React, { useEffect, useState } from 'react'
import "../../Styles/ImpactOfMultiOmicsCarousel.scss"
import ImgGenomics from "../../Assests/AboutUs/Genomics.png";
import ImgTranscriptomics from "../../Assests/AboutUs/Transcriptomics.png";
import ImgGutMicrobiome from "../../Assests/AboutUs/Gut Microbiome.png";
import ImgLipidomics from "../../Assests/AboutUs/Lipidomics.png";
import ImgMetabolomics from "../../Assests/AboutUs/Metabolomics.png";
import ImgOralMicro from "../../Assests/AboutUs/Oral Microbiome.png";
import ImgProteomics from "../../Assests/AboutUs/Proteomics.png";


// const borderColors = {
//   Genomics: "#4BD2D9",
//   Transcriptomics: "#4EBDE0",
//   "Gut Microbiome": "#4BD2D9",
//   Proteomics: "#3AB6DC",
//   Metabolomics: "#5CACEB",
//   "Oral Microbiome": "#8290DC",
//   Lipidomics: "#7CBBEF",
// };

const layers = [
  {
    name: "Genomics",
    description:
      "The study of genes and their functions focusing on how an individual’s DNA influences health, traits, and disease susceptibility.",
    image: ImgGenomics,
  },
  {
    name: "Transcriptomics",
    description:
      "The examination of RNA transcripts to understand gene activity and expression patterns shedding light on cellular responses and function.",
    image: ImgTranscriptomics,
  },
  {
    name: "Gut Microbiome",
    description:
      "The gut microbiome is the diverse community of microorganisms in the gastrointestinal tract that aids digestion and supports immune health.",
    image: ImgGutMicrobiome,
  },
  {
    name: "Proteomics",
    description:
      "The analysis of proteins and their structures, functions, and interactions within the body helping to understand biological processes and disease mechanisms.",
    image: ImgProteomics,
  },
  {
    name: "Metabolomics",
    description:
      "Metabolomics is the analysis of small molecules in biological samples providing insights into metabolic processes and disease mechanisms.",
    image: ImgMetabolomics,
  },
  {
    name: "Oral Microbiome",
    description:
      "The oral microbiome is the community of microorganisms in the mouth that impacts oral health, digestion, and immune responses.",
    image: ImgOralMicro,
  },
  {
    name: "Lipidomics",
    description:
      "The study of fats and lipids in biological systems revealing roles in energy storage, cell signaling, and metabolic health.",
    image: ImgLipidomics,
  },
];

function ImpactOfMultiOmicsCarousel() {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSelectedIndex((prevIndex) => (prevIndex + 1) % layers.length); 
    }, 4000);

    return () => clearInterval(intervalId);
  }, []);

  const handleSelection = (index) => {
    setSelectedIndex(index);
  };

  return (
    <div className='impactOfMultiOmicsCarousel d-flex justify-content-end mb-5' >
      <div  className='w-75  impactOfMultiOmicsCarousel-bg p-5 mb-5' style={{position:"relative"}}>
      <div className=" d-flex justify-content-center align-items-center" >
        {/* Funnel Layers */}
        <div className="funnel-container ">
          {layers.map((layer, index) => (
            <div
              key={index}
              className={`funnel-layer ${index === selectedIndex ? "active" : ""}`}
              style={{ width: `${100 - index * 10}%`,
              //  borderBottomColor: index === selectedIndex ? borderColors[layer.name] : "transparent",
               }}
              onClick={() => handleSelection(index)}
            >
            <div className="text-data">  {layer.name}</div>
            </div>
          ))}
        </div>

        {/* Carousel Points */}
        <div className="carousel-points" style={{ display: "grid", marginLeft: "2rem" ,height: "35vh" }}>
          {layers.map((layer, index) => (
            <span
              key={index}
              className={`carousel-point ${index === selectedIndex ? "active-point" : ""}`}
              onClick={() => handleSelection(index)}
            ></span>
          ))}
        </div>
      </div>


      {/* Details Section */}
    <div className="details-section rounded-5" >
      <div className=" d-flex justify-content-between">
    {/* <img
          src={layers[selectedIndex].image}
          alt={layers[selectedIndex].name}
          className="layer-image" style={{width:"10%"}}
        />
        <h2>{layers[selectedIndex].name}</h2>
      
        <p>{layers[selectedIndex].description}</p> */}
        <div className='fs-3 p-3 pt-4 fw-bold layer-image-heading'>{layers[selectedIndex].name}</div>
       
          <img
          src={layers[selectedIndex].image}
          alt={layers[selectedIndex].name}
          className="layer-image" style={{width:"30%"}}
        />
        
    </div>
    <div className='p-3 layer-image-description'>
    {layers[selectedIndex].description}
    </div>
      </div>
    </div>
    </div>
    
  );
}


export default ImpactOfMultiOmicsCarousel